import slick from 'slick-carousel';

jQuery( '.js-testimonial-slider' ).slick( {
	rows: 0,
	arrows: false,
	dots: true,
	adaptiveHeight: true,
	autoplay: true,
	autoplaySpeed: 6000,
	fade: true,
} );